//
// Copyright (c) 2019-Present Syncari All rights reserved.
//

import cx from 'classnames';
import { noop } from 'lodash/fp';
import { useEffect, useState } from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';

import { withI18n } from 'components/I18nProvider';
import InlineMessage from 'components/InlineMessage';
import { Stack } from 'components/layout';

import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/javascript/javascript';
import './ActionRequestResponse.less';

export interface ActionPythonTestResponseProps {
  className?: string;
  errorMsg?: string;
  testResponse?: any;
}

const ActionPythonTestResponse = ({ className, errorMsg, testResponse }: ActionPythonTestResponseProps) => {
  const [displayContent, setDisplayContent] = useState('');

  useEffect(() => {
    if (!testResponse) {
      setDisplayContent('');
      return;
    }

    const responseData = testResponse.response || testResponse.data || testResponse;
    let content = '';
    if (responseData) {
      try {
        if (typeof responseData === 'string') {
          try {
            content = JSON.stringify(JSON.parse(responseData), null, 4);
          } catch {
            content = responseData;
          }
        } else {
          content = JSON.stringify(responseData, null, 4);
        }
      } catch (error) {
        content = String(responseData);
      }
    }

    setDisplayContent(content);
  }, [testResponse]);

  const options = {
    matchBrackets: true,
    lineWrapping: true,
    autoCloseBrackets: true,
    mode: 'javascript',
    lineNumbers: true,
  };

  return (
    <Stack className={cx('synri-action-request-response', className)} spacing="md">
      <InlineMessage className="synri-action-request-response-error-msg" type={'error'} title={errorMsg} allowMultiline>
        {errorMsg}
      </InlineMessage>
      <CodeMirror value={displayContent} options={options} onBeforeChange={noop} />
    </Stack>
  );
};

export default withI18n(ActionPythonTestResponse, 'ActionSetup');
